import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { SessionData, ClassDetail } from '../../Models/Session';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { ModelService } from '../../Services/model.service';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],standalone:false
})
export class ResetPasswordComponent implements OnInit{
  items: MenuItem[] | undefined;
  home: MenuItem | undefined;
  userForm!: FormGroup;
  passForm!: FormGroup;
  authService: any;
  router: any;
  errorMessage: any;
  imageUrl: string = '';
  loading:boolean=false;
  sessions:SessionData[]=[];
  classes:ClassDetail[]=[];
  currentStep = 1;
  languges:any[]=[];
  showforget:boolean=false;
  constructor(
     private http: HttpClient,
     private auth:AuthService,
     private messageService: ModelService,
     private formBuilder:FormBuilder,
     private Api:BaseApiService
     )
  {

  }

  onSubmit() {

    if (this.userForm.valid) {
      this.loading=true;
      const formData = this.userForm.value;
      let Email=formData;
      this.Api.create("Auth/ForgotPassword",Email).subscribe(
        (response) => {
          this.loading    =false;
          this.showforget =true;
          this.passForm.get('email')?.setValue(this.userForm.get('Email')?.value);
          this.messageService.showSuccessAlert(response.message);
        },
        ( error) => {
          this.loading=false;
          this.messageService.showErrorAlert(error.error.message);
          

        }
      );
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  PassworRest() {
    if (this.passForm.valid) {
      this.loading=true;
      const formData = this.passForm.value;
      this.Api.create("Auth/RestPassword",formData).subscribe(
        (response) => {
          this.loading=false;
          this.messageService.showSuccessAlert(response.message);
          window.location.replace("/login")
        },
        ( error) => {
          this.messageService.showErrorAlert(error.error.message);
          this.loading=false;
        }
      );
    } else {
      this.userForm.markAllAsTouched();
    }
  }
  initilizaform(){
    this.loading=true
    this.userForm = this.formBuilder.group(
      {
        Email: ['', [Validators.required, Validators.email]],
      }
     );
    this.loading=false;
  }
  PasswordForm(){
    this.loading=true
    this.passForm = this.formBuilder.group(
      {
           otp:['',Validators.required],
           email: ['', [Validators.required, Validators.email]],
           password:['',Validators.required]
      }
     );
  this.loading=false;
  }

ngOnInit(): void {
  this.initilizaform();
  this.PasswordForm();
  this.passForm.get('email')?.setValue(this.userForm.get('Email')?.value);
}



}
